var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-msg-user" }, [
    _c("div", { staticClass: "viq-msg-user__avatar" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M8 8a3 3 0 100-6 3 3 0 000 6zm0 1.5c-3 0-5.5 1.5-5.5 3V14h11v-1.5c0-1.5-2.5-3-5.5-3z",
              fill: "currentColor",
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "viq-msg-user__bubble" }, [
      _c("p", { staticClass: "viq-msg-user__text" }, [
        _vm._v(_vm._s(_vm.message.content)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }